import React, { useCallback } from 'react';
import { Box, Icon, InputAdornment, TextField } from '@mui/material';
import styles from './ChooseYourPlan.module.css';
import { NormalSubscriptionPlan, ProjectAlphaSubscriptionPlan } from '../../..';
import { logoutBbl } from '../../../../common/CommonTools';
import BblButton from '../../../../component/buttons/bblButton';
import { PlanCard } from '../../../../component/parentPortal/planCard/planCard';
import { useAppSelector } from '../../../../store/hooks';
import { selectAppStateData } from '../../../../store/reducer/appStateSlice';
import { ChoosePaymentMethod } from '../../choosePaymentMethod';
import { ChooseYourPlanElement } from '../ChooseYourPlanElement';

export const DesktopView = (): JSX.Element => {
  // REDUX
  const appState = useAppSelector(selectAppStateData);
  // ELEMENT
  const chooseYourPlanElement = ChooseYourPlanElement();
  return (
    <React.Fragment>
      <div className={styles.chooseYourPlan}>
        <div className={styles.header}>
          <img
            className={styles.desktopHeaderIcon}
            id="desktop-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
          <img
            className={styles.projectAlphaIcon}
            id="entry-header"
            alt=""
            src="assets/common/project-alpha-logo.png"
          />

          <div className={styles.logoutButton}>
            <BblButton size="small" color="primary" mute onClick={logoutBbl}>
              Log Out
            </BblButton>
          </div>
        </div>
        {!chooseYourPlanElement.selectedPlan && (
          <img
            className={styles.desktopSubscriptionFooterIcon}
            id="desktop-subscription-footer"
            alt=""
            src="assets/common/desktop-subscription-footer.svg"
          />
        )}
        <section
          className={styles.chooseYourPlanMainSection}
          id="choose-your-plan-main-section"
        >
          {chooseYourPlanElement.selectedPlan ? (
            <ChoosePaymentMethod
              selectedPlan={chooseYourPlanElement.selectedPlan}
              back={chooseYourPlanElement.resetSelectedPlan}
            />
          ) : (
            <Box className={styles.chooseYourPlanMainBox}>
              <Box className={styles.chooseYourPlanTitleBox}>
                <img
                  className={styles.desktopProgressIndicator4Icon}
                  id="desktop-progress-indicator-4"
                  alt=""
                  src="assets/common/desktop-progress-indicator-4.svg"
                />
                <div className={styles.chooseYourPlanTitleDiv}>
                  Choose Your Plan
                </div>
              </Box>
              <Box className={styles.chooseYourPlanMainGroupPlDiv}>
                {chooseYourPlanElement.planList.reverse().map((p, i) => {
                  return (
                    <Box
                      key={`plan-${i}`}
                      className={styles.chooseYourPlanCardBox}
                    >
                      <PlanCard {...p} key={`plan-${i}`} fullWidth />
                    </Box>
                  );
                })}
              </Box>
            </Box>
          )}
        </section>
        {/* <section
          className={styles.chooseYourPlanSmartTipGroSection}
          id="choose-your-plan-smart-tip-group"
        >
          <section
            className={styles.chooseYourPlanSmartTipConSection}
            id="choose-your-plan-smart-tip-group"
          >
            <div className={styles.tipFrameDiv}>
              <img
                className={styles.chooseYourPlanCouponIcon}
                id="choose-your-plan-coupon-icon"
                alt=""
                src="assets/common/choose-your-plan-coupon-icon.svg"
              />
              <div className={styles.youCanAddPromotionCodeIn}>
                <p
                  className={styles.youCanAdd}
                >{`You can add Promotion Code `}</p>
                <p className={styles.codeBBAIMONTHP}>in the next step!</p>
              </div>
            </div>
          </section>
          <img
            className={styles.chooseYourPlanSmartTipStrIcon}
            id="choose-your-plan-smart-tip-stroke"
            alt=""
            src="assets/chooseYourPlan/choose-your-plan-smart-tip-stroke.svg"
          />
        </section> */}
      </div>
    </React.Fragment>
  );
};
